/* eslint-disable */
export default {
  region: 'Región',
  calling: 'Llamadas',
  logout: 'Cerrar sesión',
  version: 'Versión',
  settings: 'Configuración',
  selectToDialSMS: 'Seleccione para marcar/enviar SMS',
  selectToDial: 'Seleccione para marcar',
  selectToSMS: 'Seleccione para enviar SMS',
  clickToDial: 'Haga clic para marcar',
  autoCreateLog: 'Crear registro de llamadas automáticamente',
  autoCreateSMSLog: 'Crear registro de SMS automáticamente',
  autoLogCalls: 'Registrar llamadas automáticamente',
  autoLogNotes: 'Registrar notas automáticamente',
  autoLogSMS: 'Registrar SMS automáticamente',
  clickToSMS: 'Haga clic para enviar SMS',
  logSMSContent: 'Registrar contenido SMS',
  clickToDialSMS: 'Haga clic para marcar/enviar SMS',
  logExtensionCall: 'Registrar llamadas de extensión',
  audio: 'Audio',
  language: 'Idioma',
  feedback: 'Comentarios',
  userGuide: 'Novedades',
  quickAccess: 'Configuración de acceso rápido',
  report: 'Informe de análisis',
  shareIdea: 'Compartir una idea',
  openEntityFrom: 'Comportamiento de objetos de Salesforce',
  ctiPanelSize: 'Tamaño del panel de CTI',
  openInNewTab: 'Abrir en una nueva pestaña',
  openInCurrentTab: 'Abrir en la pestaña actual',
  reportIssue: 'Informar problema',
  contactSupport: 'Contactar a servicio al cliente',
  selectToDialHint:
    'Para una mejor experiencia, seleccione el número de teléfono para marcar con RingCentral en una página con gran cantidad de números telefónicos.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
